import DistrictsApiV2 from 'api/v2/admins/districts-api-v2'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import StringUtil from 'utils/string-util'
import InputField from 'components/molecules/input-field'

const propTypes = {
  name        : PropTypes.string,
  label       : PropTypes.string,
  required    : PropTypes.bool,
  valueType   : PropTypes.string,
  formikBag   : PropTypes.object.isRequired,
  provinceKey : PropTypes.string,
  cityKey     : PropTypes.string
}

const defaultProps = {
  name        : 'district',
  label       : 'District',
  required    : false,
  valueType   : 'id',
  provinceKey : 'province',
  cityKey     : 'city'
}

// handle nested key e.g 'address.tl_province_id'
const getValue = (values, key) => {
  const keys    = key.split('.')
  let newValues = values
  keys.map((k) => newValues = newValues[k])

  return newValues
}

/**
 * Search field to select province by name and return value is name
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {string} valueType - what the form will return value
 * @param {string} provinceKey - field name/key for province
 * @param {string} cityKey - field name/key for province
 * @param {object} formikBag
 */
const DistrictSelectField = ({
  name,
  label,
  required,
  valueType,
  provinceKey,
  cityKey,
  formikBag,
  ...props
}) => {
  const [ districts, setDistricts ] = useState([])
  const [ isLoading, setIsLoading ] = useState(false)
  const provinceValue               = getValue(formikBag.values, provinceKey)
  const cityValue                   = getValue(formikBag.values, cityKey)

  useEffect(() => {
    const filter = {
      [`province_${valueType}`] : provinceValue,
      [`city_${valueType}`]     : cityValue
    }

    if (provinceValue === '' || cityValue === '') return
    setIsLoading(true)
    DistrictsApiV2.get(filter)
      .then((response) => {
        setDistricts(response.data.tl_districts)
        setIsLoading(false)
      })
      .catch(() => {
        alert('Failed to fetch Districts')
      })
  }, [ provinceValue, cityValue, valueType ])

  // eslint-disable-next-line react/prop-types
  const SelectFieldOptions = ({ options, label }) => (
    <>
      <option value='' label={ `Choose ${label}` }/>
      {
        // eslint-disable-next-line react/prop-types
        options.map((option) => (
          <option
            key={ `select-option-city-${option.id}` }
            value={ isStringValue(option[valueType]) ? StringUtil.humanizeUpperCase(option[valueType]) : option[valueType] }
            label={ StringUtil.humanizeUpperCase(option.name) }
          />
        ))
      }
    </>
  )

  const isStringValue = (value) => typeof value === 'string' || value instanceof String

  return (
    <InputField
      type='select'
      label={ label }
      name={ name }
      required={ required }
      disabled={ isLoading }
      { ...props }
    >
      {
        isLoading ?
          <option
            key=''
            value=''
            label='Loading...'
          /> :
          <SelectFieldOptions
            options={ districts }
            label={ label }
          />
      }
    </InputField>
  )
}

DistrictSelectField.propTypes    = propTypes
DistrictSelectField.defaultProps = defaultProps

export default DistrictSelectField
